module.exports = __webpack_public_path__ + "static/media/our-projects.b19b61ad.png";